import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";

// Register Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RegisterProfessionalPage from "./pages/RegisterProfessionalPage";
import ProfessionalsPage from "./pages/ProfessionalsPage";
import ProfessionalDetailPage from "./pages/ProfessionalDetailPage";
import MatchPage from "./pages/MatchPage";
import DashboardPage from "./pages/DashboardPage";
import PaymentsPage from "./pages/PaymentsPage";
import SessionPage from "./pages/SessionPage";
import BookSessionPage from "./pages/BookSessionPage";
import FeaturedPlansPage from "./pages/FeaturedPlansPage";
import WithdrawalsPage from "./pages/WithdrawalsPage";
import AdminPage from "./pages/AdminPage";
import AuthCallback from "./pages/AuthCallback";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/register/professional" element={<RegisterProfessionalPage />} />
      <Route path="/professionals" element={<ProfessionalsPage />} />
      <Route path="/professionals/:id" element={<ProfessionalDetailPage />} />
      <Route path="/match" element={<MatchPage />} />
      <Route path="/payments" element={<PaymentsPage />} />
      <Route path="/payment/success" element={<PaymentsPage />} />
      <Route path="/payment/cancel" element={<PaymentsPage />} />
      <Route path="/session/book/:professionalId" element={<ProtectedRoute><BookSessionPage /></ProtectedRoute>} />
      <Route path="/session/:sessionId" element={<ProtectedRoute><SessionPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/featured-plans" element={<ProtectedRoute><FeaturedPlansPage /></ProtectedRoute>} />
      <Route path="/withdrawals" element={<ProtectedRoute><WithdrawalsPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
